const initialProps = {
  selectedTicket: 1,
};

export default function (state = initialProps, action) {
  switch (action.type) {
    case "UPDATE_SELECTED_TICKET":
      return {
        ...state,
        selectedTicket: action.payload,
      };
    default:
      return state;
  }
}
